import { render } from "./MinMaxItemsChecked.vue?vue&type=template&id=7a8c16ba"
import script from "./MinMaxItemsChecked.vue?vue&type=script&lang=ts"
export * from "./MinMaxItemsChecked.vue?vue&type=script&lang=ts"
script.render = render

export default script